/* global 'molecule','PregnancyWarning' */
import React from 'react';
import PropTypes from 'prop-types';
import marketConfig from 'common/src/app/config/market/market.configdefinitions';
import { withFunctionalClassName } from 'common/src/app/util/componentClassNameUtils';
import { userDetailFields } from 'common/src/app/data/enum/FieldNames/AccountFieldNames';
import TextNew from '../../atoms/TextNew';
import LocaleMessage from '../../atoms/LocaleMessage';
import Button from '../../atoms/Button';
import './pregnancy-warning.scss';

const PregnancyWarning = (
  { formValues: { [userDetailFields.IS_PREGNANT]: isPregnant } },
  {},
  className,
) =>
  isPregnant === '1' && (
    <div className={className}>
      <TextNew.PrimaryOriginal localeId="pregnancyWarning.group.title" />
      <TextNew.PrimaryOriginal localeId="pregnancyWarning.group.message" />
      <TextNew.PrimaryOriginal localeId="pregnancyWarning.group.additionalMessage" />
      <Button isGhostDark href={marketConfig.pregnancyCTAUrl} target="_blank">
        <LocaleMessage id="pregnancyWarning.group.button" />
      </Button>
    </div>
  );

PregnancyWarning.propTypes = {
  formValues: PropTypes.shape({
    [userDetailFields.IS_PREGNANT]: PropTypes.string,
  }),
};
PregnancyWarning.contextTypes = {
  getMessage: PropTypes.func.isRequired,
};

export default withFunctionalClassName('molecule','PregnancyWarning')(PregnancyWarning);
